import React, { useEffect, useState } from "react";
import {
  Col,
  Modal,
  Nav,
  Row,
  Tab,
  Image,
  Button,
  InputGroup,
  Form,
} from "react-bootstrap";
import icTitle from "../../../assets/images/ic-contacts.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Help.css";
import SearchBar from "../../../components/searchbar/SearchBar";
import TableList from "../modals/table/EditEthicsTeamContactTable";
import Pencil from "../../../assets/images/pencil.png";
import Add from "../../../assets/images/ic-add.svg";
import {
  ContactModel,
  GetContacts,
} from "../../../features/helpandassistance/contactsSlice";
import { isAdmin, isPermited } from "../../../features/localStorage";
import { formatDate } from "../../../constant/DateFormat";
import swal from "sweetalert";
import { GetDeleteEthicsTeamGroupDetails } from "../../../features/helpandassistance/deleteEthicsTeamGroupDetailsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetDeleteEthicsTeamGroup } from "../../../features/helpandassistance/deleteEthicsTeamGroupSlice";
import { GetinsertEthicsTeamGroup } from "../../../features/helpandassistance/insertEthicsTeamGroupSlice";
import FileUpload from "../../../components/textField/excelUpload";
import Search from "../../../assets/images/search-line.svg";
import { useForm } from "react-hook-form";
// Messages
const required = "This field is required";
const pattern = "Please insert valid input";

// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
interface ContactsProps {
  contact: any;
  label: string;
  isForEdit?: Boolean;
  isListShow: any;
}

type newTeamList = {
  groupName: string;
  createdBy: string;
  companyId: number;
  ethicsTeamDetails: any;
  saveButton: any;
};
const EthicsTeamContactDetails: React.FC<ContactsProps> = ({
  contact,
  label,
  isForEdit,
  isListShow,
}: ContactsProps) => {
  const [modalShow, setModalShow] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);
  const dispatch = useAppDispatch();

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const [recordRow, setRecordRow] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [groupDetailsId, setGroupId] = useState();
  const [saveButton, setSaveButton] = useState(false);
  const [name, setName] = useState("");
  const [file, setFile] = useState("");
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const [searchData, setsearchData] = useState("");
  const [tabId, setTabid] = useState();
  // useEffect(() => {

  //   setContactList(contact)

  // }, [contact]);
  // console.log(typeof(contact), contact,"contact")

  var searchParams = {
    companyId: 0,
    keyword: searchData,
  };
  const addTabList = () => {
    const createSaveButton = (
      <Col className="px-0">
        {" "}
        <Button type="submit" style={styles.button}>
          {" "}
          Save
        </Button>
      </Col>
    );
    let newMessage: newTeamList = {
      groupName: "New List",
      createdBy: "",
      companyId: 5,
      ethicsTeamDetails: [],
      saveButton: createSaveButton,
    };

    let prevMessages: any = [...contact];
    prevMessages.push(newMessage);
    setContactList(prevMessages);
    setSaveButton(true);
    //console.log(typeof(contact), contact)
  };
  const checkDeleteGroupDetailsId = (id: any) => {
    setGroupId(id);
  };

  useEffect(() => {
    setContactList(contact);
    if (file !== null || file !== undefined || file !== "") {
      GetContacts(searchParams);
    }
  }, [contact, groupDetailsId, tabId]);

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //  e.preventDefault();
    var data = {
      groupName: name,
      companyId: userDetailsJson.companyId,
    };
    await dispatch(GetinsertEthicsTeamGroup(data));
    await dispatch(GetContacts(data));
    await window.location.reload();
    setSaveButton(false);
    //window.location.reload()
  };
  const refreshList = async () => {
    await dispatch(GetContacts(searchParams));
  };
  const [checkListShow, setCheckListShow] = useState(isListShow);

  const searchItems = async (searchValue: any, obj: any) => {
    var searchParams = {
      companyId: obj.id,
      keyword: searchData,
    };
    await setsearchData(searchValue);

    await dispatch(GetContacts(searchParams));
  };
  return (
    <>
      <a
        onClick={handleShow}
        style={{
          backgroundColor: "#fff",
          color: "#e31837",
          // fontWeight: "bold",
          fontFamily: "Saira",
          fontWeight: 500,
          fontSize: "12px",
          cursor: "pointer",
        }}
      >
        {isForEdit ? (
          <>
            <Image src={Pencil} />
            <b> EDIT CONTACT DETAILS </b>
          </>
        ) : (
          <> here </>
        )}
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="xl"
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title="Ethics team contact details" />
        <ENGModalBody
          contents={
            <>
              <Tab.Container defaultActiveKey={1}>
                <Row style={styles.divWhite} className="mx-auto pb-0">
                  <Col sm={10} className="px-0">
                    <Nav>
                      {contactList?.map((obj: any, index: any) => {
                        return (
                          <Nav.Item style={styles.tabHeading} key={obj?.id}>
                            <Nav.Link className="tabs1" eventKey={index + 1}>
                              {obj.groupName}
                              <input
                                type="hidden"
                                name={groupDetailsId}
                                value={obj?.id}
                              />
                            </Nav.Link>
                          </Nav.Item>
                        );
                      })}
                    </Nav>
                  </Col>

                  {isPermited(8, 2) && (
                    <Col sm={2} className="pe-0">
                      <a
                        className="float-end"
                        style={styles.link}
                        onClick={addTabList}
                      >
                        <Image src={Add} /> Add List
                      </a>
                    </Col>
                  )}
                </Row>
                <div style={styles.line}></div>
                <Row sm={8} style={styles.divWhite} className="mx-auto">
                  <>
                    <Col sm={12} className="px-0">
                      <Tab.Content>
                        {contactList?.map((obj: any, index: any) => {
                          return (
                            <Tab.Pane eventKey={index + 1} key={obj?.id}>
                              {isPermited(7, 2) ? (
                                <form onSubmit={handleSubmit(onSubmit)}>
                                  <Row style={styles.divWhite}>
                                    <Col sm={2} className="ps-0">
                                      <div className="floating-label-group">
                                        <input
                                          type="text"
                                          name="name"
                                          className="textstyle"
                                          ref={register({
                                            required: true,
                                            pattern: /^[a-zA-Z\s]*$/g,
                                          })}
                                          onChange={(
                                            ev: React.ChangeEvent<HTMLInputElement>
                                          ): void => setName(ev.target.value)}
                                          defaultValue={obj.groupName}
                                        />
                                        <label className="floating-label">
                                          Name{" "}
                                          <span style={styles.star}> * </span>
                                        </label>
                                        {errors.designation &&
                                          errors.name.type === "required" &&
                                          errorMessage(required)}
                                        {errors.designation &&
                                          errors.name.type === "pattern" &&
                                          errorMessage(pattern)}
                                      </div>
                                    </Col>
                                    {saveButton !== true ? (
                                      <>
                                        <Col sm={3} className="mb-3">
                                          <FileUpload
                                            setFile={setFile}
                                            title="File"
                                            fileValue=""
                                            groupId={obj.id}
                                            apiUrl="ethicsTeam"
                                            refreshList={refreshList}
                                          />
                                        </Col>

                                        <Col className="px-0">
                                          <div className="px-1">
                                            <span style={styles.heading1}>
                                              Last Modified By
                                            </span>
                                            <br />
                                            <span style={styles.data}>
                                              {obj.createdBy}
                                            </span>
                                          </div>
                                        </Col>
                                        <Col className="px-0">
                                          <div className="px-1">
                                            <span style={styles.heading1}>
                                              Modified on
                                            </span>
                                            <br />
                                            <span style={styles.data}>
                                              {formatDate(obj.updatedDate)}
                                            </span>
                                          </div>
                                        </Col>
                                      </>
                                    ) : null}

                                    {obj.saveButton}
                                    <Col
                                      sm={4}
                                      xs={12}
                                      className="ms-auto pe-0 ps-1"
                                    >
                                      <InputGroup
                                        id="searchbar"
                                        style={{ border: "solid 1px #e4e4e4" }}
                                      >
                                        <Image
                                          style={styles.image1}
                                          className="d-inline border-0 my-auto mx-2"
                                          src={Search}
                                          fluid
                                        />
                                        <Form.Control
                                          onChange={(e) =>
                                            searchItems(e.target.value, obj)
                                          }
                                          name={searchData}
                                          className="border-0 shadow-none ps-0"
                                          style={styles.text1}
                                          type="text"
                                          placeholder="Search"
                                        />
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                </form>
                              ) : (
                                <Row style={styles.divWhite}>
                                  <Col sm={5} xs={12} className="ms-auto px-0">
                                    {saveButton !== true ? <SearchBar /> : null}
                                    <br />
                                  </Col>
                                </Row>
                              )}
                              {/* {isAdmin() &&
                        <Row>
                           {saveButton!==true?
                        <>
                        <Col sm={2} className="">
                            <a style={styles.link} onClick={() => onDeleteGroup(obj.id)}><Image src={Delete} /> Delete List</a>
                        </Col>
                   
                        <Col sm={1} className="ms-auto mb-3" onClick={() => setToggleDelete(!toggleDelete)}>
                          <Image src={Add2} onClick={onAddRecord}/>
                          {groupDetailsId===null?
                          <Image src={DeleteBox} onClick={onDeleteGroupDetails} className="float-end logo-img" alt="Logo"/>:
                          <Image src={DeleteBox1} onClick={onDeleteGroupDetails} className="float-end logo-img" alt="Logo"/>
                            }
                        </Col>
                        </>:null}
                        </Row>
                       }                            */}
                              {saveButton !== true ? (
                                <TableList
                                  tData={obj.ethicsTeamDetails}
                                  id={obj.id}
                                  checkDeleteGroupDetailsId={
                                    checkDeleteGroupDetailsId
                                  }
                                  checkListShow={checkListShow}
                                  searchData={searchData}
                                  setGroupId={setGroupId}
                                />
                              ) : null}
                            </Tab.Pane>
                          );
                        })}
                      </Tab.Content>
                    </Col>
                  </>
                </Row>
              </Tab.Container>
            </>
          }
        />
        {saveButton !== true ? (
          <ENGModalFooter closeMethod={handleClose} />
        ) : null}
      </Modal>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    padding: "15px",
  },
  star: { color: "#e31837" },
  button: {
    padding: "15px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
  tabHeading: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  edit: {
    fontSize: "10px",
    fontWeight: "normal",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#f4f4f4",
  },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
  },
  colBorder: {
    border: "solid 1px #e4e4e4",
  },
  heading1: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  data: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
  },
  data1: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
    border: "0px",
    boxShadow: "none",
    padding: "0px",
    paddingBottom: "6px",
  },
  image1: {
    width: "24px",
    height: "24px",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    color: "#6d6e71",
  },
};

export default EthicsTeamContactDetails;
